// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3TRbY","rootCenter":"LoadMoreObserver_rootCenter__3qdTq","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__a9Do1"};